import React from 'react'
import styled from '@emotion/styled'

const SvgWrapper = styled.div`
  display: inline-block;
  flex: 0 0 21px 24px;
  width: 21px;
  height: 24px;
  min-width: 21px;
  min-height: 24px;
  position: relative;
  color: inherit;
`

const InlineSvg = styled.svg`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  color: inherit;
  fill: currentColor;
`

const SecureSwapMark = props => (
  <SvgWrapper {...props}>
    <InlineSvg
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1.414"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
      viewBox="0 0 21 24"
      preserveAspectRatio="xMidYMid meet"
      id="secure-swap-badge"
    >
      <title id="title">Secure Swap</title>
      <g>
        <path
          d="M0 1v11.5c0 4.83 4.237 9.2 10.5 11.5C16.763 21.7 21 17.33 21 12.5V1H0z"
          fillOpacity=".2"
          fill="#001319"
        />
        <path
          d="M0 0v11.5c0 4.83 4.237 9.2 10.5 11.5C16.763 20.7 21 16.33 21 11.5V0H0z"
          fill="#FAF9F8"
        />
        <path
          d="M2 11.5c0 4.037 3.43 7.6 8.5 9.5 5.07-1.9 8.5-5.463 8.5-9.5V2H2v9.5z"
          fill="#00CE5C"
        />
        <path
          d="M16.923 7.62a.228.228 0 0 1 .001.341l-7.444 6.97a.276.276 0 0 1-.364 0l-1.669-1.564-.363-.338-2.01-1.883a.231.231 0 0 1 0-.34l1.671-1.563a.269.269 0 0 1 .364 0l2.009 1.88a.269.269 0 0 0 .363 0L14.88 6.07a.273.273 0 0 1 .365 0l1.68 1.55z"
          fill="#FFF"
        />
      </g>
    </InlineSvg>
  </SvgWrapper>
)

export default SecureSwapMark
